{{ today | date }}<div style="text-align: center;font-weight: bold; font-size: larger;">{{heading}}</div>

<ng-container *ngTemplateOutlet="currentTemplate">
</ng-container>
